import * as React from 'react';
import { trackClickLayoutsSeoLink } from './tracking';
import { LayoutsLink } from '../../components/LayoutsLink';
import { useApplicationContext } from '../../utils/withApplicationContext';

export const LayoutsLinkContainer = () => {
  const { config } = useApplicationContext();
  const isEnabled = config.get('Newbuilding.LayoutsSeoPage.Enabled');

  if (!isEnabled) {
    return null;
  }

  return <LayoutsLink url="planirovki/" onClick={trackClickLayoutsSeoLink} />;
};
